<template>
  <div class="container-box">
    <!-- 表单内容 -->
    <el-form ref="form" :inline="true" :model="qualityData">
      <div class="form-container">
        <!-- 反馈单号 -->
        <el-form-item :label="$t('zlfk.fkdh') + ':'">
          <el-input
            v-if="!isLookOperate"
            disabled
            v-model="qualityData.feedbackFormId"
          ></el-input>
          <b v-else>{{ qualityData.feedbackFormId }}</b>
        </el-form-item>
      </div>
    </el-form>
    <div>
      <!-- 车辆信息 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img src="@/assets/image/carInfo.png" alt="" />
          {{ $t("zlfk.clxx") }}
        </div>
      </div>
      <el-form
        ref="form"
        :inline="true"
        :model="qualityData"
        :rules="formRules"
        :label-width="labelWidth"
      >
        <!-- 编辑时显示输入框 -->
        <div class="form-container" v-if="!isLookOperate">
          <!-- VIN码 -->
          <el-form-item :label="$t('zlfk.vin') + ':'" prop="vin">
            <el-input
              v-model="qualityData.vin"
              :placeholder="$t('placeholder.enter')"
              @blur="handleBlur"
              @focus="handleFocus"
              @change="getCarModel"
            />
          </el-form-item>
          <!-- 车型 -->
          <el-form-item :label="$t('home.carType') + ':'" prop="carModel">
            <el-input v-model="qualityData.carModel" :placeholder="$t('placeholder.enter')" />
          </el-form-item>
          <!-- 车辆属性 -->
          <el-form-item :label="$t('zlfk.clsx') + ':'" prop="carAttribute">
            <el-select
              v-model="qualityData.carAttribute"
              filterable
              clearable
            >
              <el-option :label="$t('climant.ryc')" :value="0"> </el-option>
              <el-option :label="$t('climant.ddc')" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 销售日期 -->
          <el-form-item :label="$t('zlfk.xsrq') + ':'" prop="saleDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="qualityData.saleDate"
              :placeholder="$t('placeholder.select')"
            ></el-date-picker>
          </el-form-item>
          <!-- 生产日期 -->
          <el-form-item :label="$t('seek.produceDate') + ':'" prop="productionDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="qualityData.productionDate"
              :placeholder="$t('placeholder.select')"
            ></el-date-picker>
          </el-form-item>
          <!-- 行驶里程 -->
          <el-form-item
            :label="$t('seek.distance') + ':'"
            prop="drivingDistance"
          >
            <el-input-number
              class="number-input"
              :controls="false"
              :precision="0"
              v-model="qualityData.drivingDistance"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input-number>
            <div class="number-input-append">km</div>
          </el-form-item>
        </div>
        <!--查看是显示数据 -->
        <div class="form-container" v-else>
          <el-descriptions class="desc-container" :column="3" border>
            <el-descriptions-item :label="$t('zlfk.vin')">
              {{ qualityData.vin }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('home.carType')">
              {{ qualityData.carModel }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('zlfk.clsx')">
              {{
                qualityData.carAttribute == 0
                  ? $t("climant.ryc")
                  : $t("climant.ddc")
              }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('zlfk.xsrq')">
              {{ qualityData.saleDate }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('seek.produceDate')">
              {{ qualityData.productionDate }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('seek.distance')">
              {{ qualityData.drivingDistance }}km
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </el-form>
    </div>
    <div>
      <!-- 故障信息 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img src="@/assets/image/faultInfo.png" alt="" />
          {{ $t("zlfk.gzxx") }}
        </div>
      </div>
      <!-- 表格搜索条件表单 -->
      <div class="filter-container" v-if="isLookOperate">
        <el-form
          :inline="true"
          :model="queryParams"
          :label-width="searchLabelWidth"
        >
          <!-- 问题序号 -->
          <el-form-item :label="$t('zlfk.wtbh') + ':'">
            <el-input
              v-model="queryParams.questionNum"
              :placeholder="$t('home.placeholder')"
            ></el-input>
          </el-form-item>
          <!-- 故障描述 -->
          <el-form-item :label="$t('restockInfo.gzxxms') + ':'">
            <el-input
              v-model="queryParams.questionContent"
              :placeholder="$t('home.placeholder')"
            ></el-input>
          </el-form-item>
          <!-- 状态 -->
          <el-form-item :label="$t('climant.status') + ':'">
            <el-select filterable clearable v-model="queryParams.status">
              <el-option :label="$t('climant.noSubmit')" :value="0"></el-option>
              <el-option :label="$t('zlfk.clz')" :value="1"></el-option>
              <el-option :label="$t('zlfk.dqr')" :value="2"></el-option>
              <el-option :label="$t('zlfk.bbh')" :value="3"></el-option>
              <el-option :label="$t('home.closed')" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 搜索按钮区域 -->
        <div class="searchButton">
          <div></div>
          <div>
            <el-button class="primary-btn" type="primary" @click="doSearch">
              <i class="subSearch-icon"></i>
              {{ $t("home.query") }}
            </el-button>
            <el-button
              class="primary-btn"
              icon="el-icon-refresh-right"
              plain
              @click="handleResetQuery"
            >
              {{ $t("home.reset") }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 表格内容 -->
      <div class="table-container">
        <div class="table-btn">
          <!-- 新增问题 -->
          <el-button
            v-if="!isLookOperate"
            class="primary-btn"
            type="primary"
            @click="handleAddOrEdit($t('zlfk.xzwt'))"
            icon="el-icon-plus"
          >
            {{ $t("zlfk.xzwt") }}
          </el-button>
        </div>
        <el-table
          ref="tableRef"
          stripe
          border
          highlight-current-row
          :data="tableData"
        >
          <!-- 序号 -->
          <el-table-column
            :label="$t('cart.xh')"
            width="60px"
            align="center"
            :render-header="$globalRenderHeader"
          >
            <template slot-scope="scope">
              {{ getColumnIndex(scope.$index) }}
            </template>
          </el-table-column>
          <!-- 问题编号 -->
          <el-table-column
            property="questionNum"
            :label="$t('zlfk.wtbh')"
            min-width="120px"
            :render-header="$globalRenderHeader"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-if="isLookOperate"
                class="lineTheme"
                @click="handleLook(scope.row)"
              >
                {{ scope.row.questionNum }}
              </div>
              <div v-else>{{ scope.row.questionNum }}</div>
            </template>
          </el-table-column>
          <el-table-column
            property="importantType"
            :label="$t('zlfk.sfzdwt')"
            width="110px"
            :render-header="$globalRenderHeader"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.importantType == 1"
                style="color: #f56c6c"
                >{{ $t("seek.yes") }}</span
              >
              <span v-if="scope.row.importantType == 0">{{
                $t("seek.no")
              }}</span>
            </template>
          </el-table-column>
          <!-- 故障描述 -->
          <el-table-column
            property="questionContent"
            :label="$t('restockInfo.gzxxms')"
            min-width="200px"
            :render-header="$globalRenderHeader"
          >
          </el-table-column>
          <!-- 重复性 -->
          <el-table-column
            property="repeatability"
            :label="$t('restockInfo.cfx')"
            min-width="100px"
            :render-header="$globalRenderHeader"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.repeatability == 0">
                {{ $t("restockInfo.exist") }}
              </div>
              <div v-if="scope.row.repeatability == 1">
                {{ $t("restockInfo.occasional") }}
              </div>
            </template>
          </el-table-column>
          <!-- 故障发生日期 -->
          <el-table-column
            property="happenDate"
            :label="$t('zlfk.gzfsrq')"
            width="180px"
            :render-header="$globalRenderHeader"
            align="center"
          >
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            v-if="isLookOperate"
            property="status"
            :label="$t('climant.status')"
            width="120px"
            :render-header="$globalRenderHeader"
            align="center"
          >
            <template slot-scope="scope">
              <div class="statusDetail" v-if="scope.row.status === 0">
                <img src="@/assets/image/draft.png" alt="" />
                <span>{{ $t("climant.noSubmit") }}</span>
              </div>
              <div class="statusDetail" v-if="scope.row.status === 1">
                <img src="@/assets/image/submitted.png" alt="" />
                <span>{{ $t("zlfk.clz") }}</span>
              </div>
              <div class="statusDetail" v-if="scope.row.status === 2">
                <img src="@/assets/image/confirmed.png" alt="" />
                {{ $t("zlfk.dqr") }}
              </div>
              <div class="statusDetail" v-if="scope.row.status === 3">
                <img src="@/assets/image/canceled.png" alt="" />
                {{ $t("zlfk.bbh") }}
              </div>
              <div class="statusDetail" v-if="scope.row.status === 4">
                <img src="@/assets/image/completed.png" alt="" />
                {{ $t("home.closed") }}
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('cart.operate')"
            :render-header="$globalRenderHeader"
            :width="
              isLookOperate
                ? '105px'
                : { ru: 205, es: 140, vi: 140 }[$i18n.locale] || '115'
            "
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- 查看 -->
              <el-button
                v-if="isLookOperate"
                type="text"
                @click="handleLook(scope.row)"
                >{{
                  scope.row.status === 2 || scope.row.status === 3
                    ? $t("restockInfo.process")
                    : $t("operate.view")
                }}</el-button
              >
              <!-- 编辑 -->
              <el-button
                v-if="!isLookOperate"
                type="text"
                @click="
                  handleAddOrEdit($t('zlfk.bjwt'), scope.row, scope.$index)
                "
                >{{ $t("home.edit") }}</el-button
              >
              <!-- 删除 -->
              <el-button
                v-if="!isLookOperate"
                type="text"
                @click="handleDelete(scope.row, scope.$index)"
                >{{ $t("cart.delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="fenye">
          <pagination
            v-if="total > 0"
            :total="total"
            :page.sync="pageNum"
            :limit.sync="pageSize"
            @pagination="handlePaginationChange"
          />
        </div>
      </div>
      <after-problem-dialog ref="afterProblemDialog" @success="updateProblem" />
    </div>
    <div class="flex_default_center" v-if="!isLookOperate">
      <el-button
        class="primary-btn lang-but"
        @click="handleSave"
        :disabled="isInputFocused ?  true : false"
        >{{ $t("home.save") }}</el-button
      >
      <!-- <el-button
        class="primary-btn lang-but"
        plain
        @click="back"
        >{{ $t("seek.cancel") }}</el-button
      > -->
      <!-- <el-button size="small" class="primary-btn" type="primary" @click="back">
        {{
          $route.query.operate === "look"
            ? $t("zlfk.backto")
            : $t("seek.cancel")
        }}
      </el-button>
      <el-button
        v-if="$route.query.operate !== 'look'"
        size="small"
        class="primary-btn"
        type="primary"
        @click="handleSave"
      >
        {{ $t("home.confirm") }}
      </el-button> -->
    </div>
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import { getStorage, setStorageNew } from "@/util/localStor";
import {
  getCarDataByVinApi,
  afterFeedbackAddApi,
  afterFeedbackEditApi,
  preAfterSalesQuestionListApi,
  getVehicleAmountByOrderNumber,
} from "@/api/feedback";
import { requiredLocation } from "@/util/qualityUtil/requiredLocation";
import AfterProblemDialog from "./afterProblemDialog.vue";
export default {
  components: {
    AfterProblemDialog,
  },
  mixins: [listCurd],
  data() {
    return {
      pageName: {
        add: "zlfk.xzfkd",
        edit: "zlfk.bjfkd",
        look: "zlfk.ckfkd",
      }, // 页面标题
      isLookOperate: false,
      qualityData: {}, // 质量反馈数据
      problemIndex: 0, // 操作问题列表索引
      queryParams: {
        feedbackFormId: "",
      }, // 查询参数
      listMethod: preAfterSalesQuestionListApi, // 获取表格数据api
      vinValid: "",
      type: "afterSalesDetail",
      isInputFocused: false
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "85px",
        en: "145px",
        vi: "135px",
        fa: "95px",
      };
      return widthMap[this.$i18n.locale] || "185px";
    },
    searchLabelWidth() {
      const widthMap = {
        zh: "95px",
        ru: "280px",
        en: "235px",
        vi: "160px",
        es: "255px",
      };
      return widthMap[this.$i18n.locale] || "130px";
    },
    formRules() {
      return {
        carAttribute: [{ required: true, message: " " }],
        vin: [{ required: true, message: " " }],
        carModel: [{ required: true, message: " " }],
        saleDate: [{ required: true, message: " " }],
        productionDate: [{ required: true, message: " " }],
        drivingDistance: [{ required: true, message: " " }],
      };
    },
  },
  created() {
    // 页面标题
    this.$route.meta.title = this.pageName[this.$route.query.operate];
    this.isLookOperate = this.$route.query.operate === "look" ? true : false;
    sessionStorage.removeItem("goBackPath");
    // 质量反馈详情数据
    this.qualityData = getStorage("qualityData");
    this.qualityData.delQuestionList = []; // 删除问题列表记录
    if (this.qualityData.feedbackFormId) {
      this.getList();
    }
    if (this.$route.meta.title === "zlfk.bjfkd") {
      // this.getCarModel();
    }
  },
  methods: {
    // 查询参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      params.feedbackFormId = this.qualityData.feedbackFormId;
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // (新增 | 编辑)问题
    handleAddOrEdit(title, data = {}, index) {
      this.problemIndex = index ?? this.tableData.length;
      this.$refs.afterProblemDialog.init(
        title,
        {
          ...data,
          orderNum: this.qualityData.orderNum || data.orderNum,
          carTotal: this.qualityData.carTotal || data.carTotal,
        },
        "edit"
      );
    },
    // 查看问题
    handleLook(data) {
      setStorageNew("problemData", data);
      this.getSetItem();
      sessionStorage.setItem("goBackPath", this.$route.fullPath);
      this.$router.push("/qualityNew/afterProblemDetail");
    },
    // 修改问题
    updateProblem(data) {
      this.$set(this.tableData, this.problemIndex, data);
    },
    // 删除问题
    handleDelete({ questionId }, index) {
      this.$confirm(
        `${this.$t("zlfk.qrsc")}？`,
        this.$t("cart.delete"),
        {
          confirmButtonText: this.$t("seek.confirm"),
          cancelButtonText: this.$t("seek.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          questionId && this.qualityData.delQuestionList.push({ questionId });
          this.tableData.splice(index, 1);
        })
        .catch((err) => {
          // this.$DonMessage.error(err);
        });
    },
    // 筛选条件
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // 通过vin获取车型
    handleBlur() {
      this.isInputFocused = false;
    },
    handleFocus(){
      this.isInputFocused = true;
    },
    async getCarModel() {
      // this.vinValid = "正在获取epc数据";
      this.vinValid = this.$t("restockInfo.submitTip");
      const res = await getCarDataByVinApi({
        data: {
          vin: this.qualityData.vin,
        },
      });
      if (res.status == 0) {
        this.$set(this.qualityData, "carModel", res.data?.carModel || "");
        this.$set(this.qualityData, "orderNum", res.data?.orderNum || "");
        this.$set(
          this.qualityData,
          "productionDate",
          res.data?.vinCreated || ""
        );
        const res2 = await getVehicleAmountByOrderNumber(
          this.qualityData.orderNum
        );
        if (res2.status == 0) {
          this.qualityData.carTotal = res2.data || undefined;
          this.vinValid = "成功";
        } else {
          this.qualityData.carTotal = undefined;
          this.$DonMessage.error(res2.message);
          this.vinValid = "vin码对应的订单号未查询到订单数量";
        }
      } else {
        this.$set(this.qualityData, "carModel", this.qualityData.carModel);
        this.$set(this.qualityData, "productionDate", this.qualityData.productionDate);
        this.$set(this.qualityData, "orderNum", "");
        this.qualityData.carTotal = undefined;
        this.$DonMessage.error(res.message);
        this.vinValid = "vin码不存在，未获取到车型和订单号";
      }
      
    },
    // 获取提示信息
    getRequiredTips(object) {
      const propLabelMap = {
        vin: "zlfk.vin",
        carAttribute: "zlfk.clsx",
        saleDate: "zlfk.xsrq",
        drivingDistance: "seek.distance",
      };
      let errorLabels = [];
      if (object) {
        Object.keys(object).forEach((prop) => {
          let label = "";
          if (propLabelMap[prop]) {
            label = this.$t(propLabelMap[prop]);
          }
          if (label && !errorLabels.includes(label)) {
            errorLabels.push(label);
          }
        });
      }
      if (errorLabels.length > 0) {
        this.$DonMessage.warning(
          `${errorLabels.join(", ")} ${this.$t("restockInfo.nullTip")}`
        );
      } else {
        this.$DonMessage.warning(this.$t("restockInfo.required"));
      }
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (!valid) {
          requiredLocation();
          this.getRequiredTips(object);
          return;
        }
        // if (this.vinValid != "成功") {
        //   this.$DonMessage.error(this.vinValid);
        //   return;
        // }
        try {
          const submitData = JSON.parse(JSON.stringify(this.qualityData));
          submitData["languageType"] = this.$i18n.locale;
          submitData.questionList = [];
          this.tableData.map((item) => {
            if (!this.qualityData.carTotal) {
              this.qualityData.carTotal = item.carTotal
            }
            if (!this.qualityData.orderNum) {
              this.qualityData.orderNum = item.orderNum
            }
            submitData.questionList.push({ ...item, ...this.qualityData });
            
          });
          let res = {};
          if (submitData.feedbackFormId) {
            res = await afterFeedbackEditApi({ data: submitData });
          } else {
            res = await afterFeedbackAddApi({ data: submitData });
          }
          if (res.status == 0) {
            this.$DonMessage.success(this.$t("message.czcg"));
            this.back();
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
  },
};
</script>
